import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/quinscape': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M313.6 474.6c4.4 4.4 8.1 9 13.3 12.5-18.5 5.6-49.2 10.1-68.5 10.1-0.5 0-1.4 0-1.9 0-135 0-244.5-109.5-244.5-244.6 0-135.1 109.4-244.6 244.5-244.6s244.6 109.5 244.6 244.6c0 35.3-6.9 67.4-20.3 97.7-3-5.7-7.2-10.2-11.2-15.3 11.2-93.5-62.1-176.6-157-176.6-87.3 0-158.1 70.8-158.1 158.1s70.8 158.1 158.1 158.1h1zM313.5 474.5l0.4 0.1zM391.9 305.6c54.7 0 99.2 44.4 99.2 99.2v0c0 54.8-44.4 99.2-99.2 99.2-54.8 0-99.2-44.4-99.2-99.2 0-54.8 44.4-99.2 99.2-99.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/quinscape.js
// module id = 978
// module chunks = 0